import {Grid, Box, Typography, Container} from '@material-ui/core';
import Image from 'next/image';
import * as dayjs from 'dayjs';
// import DOMPurify from 'isomorphic-dompurify';
import {useRouter} from 'next/router';
import {Alert} from '@material-ui/lab';
import {useQuery} from '@apollo/client';
import dynamic from 'next/dynamic';

import {maybe} from 'src/core/utils';
import useStorefrontData from 'src/hooks/useStorefrontData';
// import {
//   BlogInfoPopup,
//   useBlogInfoPopup
// } from 'src/componentsNext/BlogInfoPopup';

import {useStyles} from './styled';
import {BlogPageQuery} from './queries';

import {Loading} from 'src/components/Loading';
import {RichTextContent} from 'src/components/RichTextContent';

// const RichTextContent = dynamic(
//   () =>
//     import('src/components/RichTextContent').then(mod => mod.RichTextContent)
//   // {ssr: false}
// );

export const Content = ({blogPage}) => {
  const classes = useStyles();
  const {user} = useStorefrontData();
  // const {onClose, onClick, timeSpent, setTimeSpent, isTabActive, open} =
  //   useBlogInfoPopup();

  const router = useRouter();
  const {slug} = router.query;

  const {data} = useQuery(BlogPageQuery, {
    skip: !slug,
    variables: {
      slug
    },
    onCompleted: data => {
      const isStaffUser = maybe(() => user.isStaff);

      if ((!data.blogPage || blogPage) && isStaffUser === false) {
        router.replace('/');
      }
    }
  });

  const blog = maybe(() => data?.blogPage, blogPage);

  if (!blog) {
    return <Loading />;
  }

  return (
    <>
      <Container>
        <Typography variant='h3' component='h1' className={classes.blogTitle}>
          {blog.title}
        </Typography>
        <Grid container>
          <Grid item xs={12}>
            {!blog.isPublished && (
              <Alert severity='warning'>
                You are viewing unpublished page!
              </Alert>
            )}
            <Box pt={2} pb={2}>
              <Typography variant='body2' suppressHydrationWarning>
                {dayjs(blog.created).format('DD MMM YYYY, hh:mm')}
              </Typography>
            </Box>
            <div className={classes.image}>
              <Image
                src={blog.banner && blog.banner.url}
                alt={blog.title}
                width={1232}
                height={666}
                priority
              />
            </div>
            <RichTextContent htmlContent={blog.content} />
          </Grid>
        </Grid>
      </Container>

      {/*<BlogInfoPopup*/}
      {/*  open={open}*/}
      {/*  isTabActive={isTabActive}*/}
      {/*  setTimeSpent={setTimeSpent}*/}
      {/*  timeSpent={timeSpent}*/}
      {/*  onClose={onClose}*/}
      {/*  onClick={onClick}*/}
      {/*/>*/}
    </>
  );
};
